import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'app-message-name-avatar',
  imports: [],
  templateUrl: './message-name-avatar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageNameAvatarComponent {
  public name = input('');
  public nameInitials = computed(() => {
    if (this.name()) {
      const nameParts = this.name().split(' ');
      console.log(nameParts);
      if (nameParts.length === 1) {
        return nameParts[0].charAt(0).toUpperCase();
      } else if (nameParts.length > 1) {
        return nameParts[0].charAt(0).toUpperCase() + nameParts[1].charAt(0).toUpperCase();
      }
    }
    return '';
  });
}
